import { postForm, resolveApiUrl } from './client.js'

/**
 * Upload a spreadsheet (.xlsx / .csv) to the harness. The file bytes never enter
 * chat message content — the server stores them and returns a small metadata
 * stub that the SPA appends to the outgoing message text (for the model) plus a
 * per-sheet summary for the widget's own UI.
 *
 * POST /api/files — multipart form: { file, sessionId }.
 * Returns { fileHandle, fileName, sizeBytes, stub, sheets: [...] }.
 */
export async function uploadFile(sessionId, file) {
  const form = new FormData()
  form.append('file', file)
  form.append('sessionId', sessionId)
  return postForm('/files', form)
}

/**
 * Download a generated/uploaded file via a throwaway anchor pointing straight at
 * the download endpoint. The endpoint is guarded by the unguessable handle plus
 * the sessionId query parameter already baked into the URL — no auth headers —
 * so no fetch is needed. Crucially this avoids blob: object URLs: host pages
 * with a CSP like `default-src https: 'self'` block blob: anchor downloads
 * (Firefox checks them against frame-src), while a plain https: URL passes.
 * The server's Content-Disposition: attachment supplies the filename; the
 * download attribute is a same-origin hint on top.
 */
export function downloadFile(url, filename) {
  const a = document.createElement('a')
  a.href = resolveApiUrl(url)
  a.download = filename || ''
  document.body.appendChild(a)
  a.click()
  a.remove()
}
